/* eslint-disable */
import React from "react";
import IconButton from "@mui/material/IconButton";

import * as Styles from "./styles";
import { useHistory } from "react-router-dom";

interface PermissoesProps {
  idPermissao: string;
  chave: string;
}

interface LocaisProps {
  idLocal: string;
  nome: string;
}

interface EmpreendimentosProps {
  idEmpreendimento: string;
  nome: string;
}

interface UserData {
  acessoAdmin: boolean;
  acessoMobile: boolean;
  ativo: true;
  celular: string | null;
  email: string;
  id: string;
  idCorretor: string;
  idPerfilCorretor: string;
  idRegional: string;
  nome: string;
  nomeFotoUsuario: string;
  nomePerfilAcesso: string;
  nomeRegional: string;
  siglaNome: string;
  empreendimentos: EmpreendimentosProps[];
  locais: LocaisProps[];
  permissoes: PermissoesProps[];
}

interface Props {
  data: UserData;
}

const ListItem: React.FC<Props> = ({ data }) => {
  const history = useHistory();

  const handleNavigate = (item: any) => {
    localStorage.setItem("@userlog", JSON.stringify(item));
    history.push({
      pathname: `/log-usuarios/${data.id}`,
      state: {
        // location state
        data: item,
      },
    });
  };

  return (
    <Styles.Container>
      <Styles.RowAlign>
        {data?.nomeFotoUsuario?.length <= 77 ? (
          <Styles.UserIcon />
        ) : (
          <Styles.Image src={data?.nomeFotoUsuario} />
        )}
        <Styles.Column>
          <Styles.Text>{data?.nome}</Styles.Text>
          <Styles.LightText>{data?.email}</Styles.LightText>
        </Styles.Column>
      </Styles.RowAlign>
      {data?.siglaNome !== null ? (
        <Styles.SiglaBadge>
          <Styles.SiglaText>{data?.siglaNome}</Styles.SiglaText>
        </Styles.SiglaBadge>
      ) : null}

      <Styles.StatusIndicator color={data?.ativo ? "#d6f7d5" : "#ffcac4"}>
        <Styles.StatusText color={data?.ativo ? "#46bd31" : "#f23e11"}>
          {data?.ativo ? "Ativo" : "Inativo"}
        </Styles.StatusText>
      </Styles.StatusIndicator>
      <IconButton
        // href={`/log-usuarios/${data.id}`}
        onClick={() => handleNavigate(data)}
        aria-label="foward"
        style={{ backgroundColor: "#f0f0f0" }}
      >
        <Styles.ArrowRightIcon />
      </IconButton>
    </Styles.Container>
  );
};

export default ListItem;
